module.exports = __webpack_public_path__ + "img/oak-yellow-acorns.e5a0bf05.jpg";